import { HttpClaimPlanOrderManageList, HttpExportClaimPlanOrderManage, HttpClaimPlanOrderManageComplete, HttpClaimPlanOrderManageDestroy, HttpClaimPlanOrderManageDestroyComplete, HttpClaimPlanOrderCount, HttpClaimPlanOrderReprocess, HttpClaimPlanOrderIgnoreError } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import compPhoto from '../photo.vue';
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,
        compPhoto,
	},
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: {
                show: true,
                // key: 'EQ_saleReturnPlanStatus'
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
            formData: {
                search: {
                    quanbu:0
                }
            },
            spanTabs: { show: true },
            exportdata: {},
        };
    },
    methods: {
        ajaxRequest: HttpClaimPlanOrderManageList,
        interceptRequest(params){
            if(params.search.quanbu === 0){
                params.search.EQ_status = ''
            }
            if(params.search.dairenling === 0){
                params.search.EQ_status = 0
            }
            if(params.search.daichuli === 0){
                params.search.EQ_status = 5
            }
            if(params.search.chulizhong === 0){
                params.search.EQ_status = 10
            }
            if(params.search.daixiaohui === 0){
                params.search.EQ_status = 20
            }
            if(params.search.yixiaohui === 0){
                params.search.EQ_status = 25
            }
            if(params.search.yichang === 0){
                params.search.NE_errorStatus=99999
            }
            delete params.search.quanbu;
            delete params.search.dairenling;
            delete params.search.daichuli;
            delete params.search.chulizhong;
            delete params.search.daixiaohui;
            delete params.search.yixiaohui;
            delete params.search.yichang;
            this.exportdata=params
            return params
        },
        spanAjaxRequest: () => {
            return HttpClaimPlanOrderCount({
                isManage: true
            })
        },
        handleOperates(params, type) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(',')) + '';
            //     if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: "请选择至少一条数据" }));
            // }
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportClaimPlanOrderManage, this.exportdata, { executor: 'request', download: true });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeids: params,
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "claimOrderManageDetail",
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'handleComplete':
                    this.operate = {
                        show: true,
                        title: "处理完成",
                        alert: "success",
                        width: "middle",
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpClaimPlanOrderManageComplete,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                    }
                    break;
                case 'destroy':
                    this.operate = {
                        show: true,
                        title: "销毁包裹",
                        alert: "warning",
                        width: "middle",
                        desc:'操作后单据状态将变为“待销毁”!',
                        params: { id: params },
                        ajaxRequest: HttpClaimPlanOrderManageDestroy,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                    }
                    break;
                case 'destroyComplete':
                    this.operate = {
                        show: true,
                        title: "销毁完成",
                        alert: "error",
                        width: "middle",
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpClaimPlanOrderManageDestroyComplete,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                    }
                    break;
                case "rehandle":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: '重处理',
                        ajaxRequest: HttpClaimPlanOrderReprocess,
                        showDesc: true,
                    }
                    break;
                case "ignoreAbnormal":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: '忽略异常',
                        ajaxRequest: HttpClaimPlanOrderIgnoreError,
                        showDesc: true,
                    }
                    break;
                case "image":
                    this.operate = {
                        show: true,
                        title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                        component: "compPhoto",
                        currentUrl: params.url,
                        urlList: params.urlList,
                        showFooter: false,
                        width: 1200,
                    }
            }
        },
        getOperateNodeMap(row) {
            const { id, status, errorStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: this.$t('', { defaultValue: "处理完成" }),
                show: status == 10,
                params: id,
                operate: 'handleComplete'
            },
            {
                label: this.$t('', { defaultValue: "销毁包裹" }),
                show: status == 0,
                params: id,
                operate: 'destroy'
            },
            {
                label: this.$t('', { defaultValue: "销毁完成" }),
                show: status == 20,
                params: id,
                operate: 'destroyComplete'
            },
            {
                label: "重处理",
                show: errorStatus !== 99999,
                params: id,
                operate: 'rehandle'
            },
            {
                label: "忽略异常",
                show: errorStatus !== 99999,
                params: id,
                operate: 'ignoreAbnormal'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                show: this.handleAuth('fbb.returnplan.export'),
                operate: "export",
            }]
        },
        TabsData() {
            return [
                {
                    name: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0,
                    spanKey: "allQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待认领' }),
                    key: 'dairenling',
                    val: 0,
                    spanKey: "unclaimedQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待处理' }),
                    key: 'daichuli',
                    val: 0,
                    spanKey: "unprocessedQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '处理中' }),
                    key: 'chulizhong',
                    val: 0,
                    spanKey: "processingQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待销毁' }),
                    key: 'daixiaohui',
                    val: 0,
                    spanKey: "undestroyedQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已销毁' }),
                    key: 'yixiaohui',
                    val: 0,
                    spanKey: "destroyedQty"
                },
                {
                    name: this.$t('', { defaultValue: '异常' }),
                    key: 'yichang',
                    val: 0,
                    spanKey: "errorQty"
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 218px;'
            return [
                {
                    label: this.$t('', { defaultValue: "认领单号" }),
                    key: 'EQ_claimPlanNo',
                    tag: 'vInput',
                    show: true,
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue : '来源单号' }),
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    show: true,
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "Tracking No" }),
                    key: 'EQ_trackingNo',
                    tag: 'vInput',
                    show: true,
                    style: 'width: 172px; margin-right:20px',
                },
                {
                    label: this.$t('', { defaultValue: "状态" }),
                    key: 'IN_status',
                    tag: 'Select',
                    options: this.getOrderStatus.slice(1),
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'Select',
                    options: this.getUserManageWarehouseList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                    tag: 'Select',
                    key: 'EQ_errorStatus',
                    options: this.getErrorSimpleType1,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                // {
                //     type: 'selection',
                //     formName: 'id',
                //     width: 60,
                // },
                {
                    title: 'No.',
                    type:"index",
                    width: 60,
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    width: 100,
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId) || '--'
                },
                {
                    title: this.$t('', { defaultValue: "认领单号" })+'/'+this.$t('', { defaultValue: "来源单号" }),
                    width: 250,
                    key: 'claimPlanNo',
                    render: (h, { row }) => {
                        return <div>
                            <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.claimPlanNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <div>{row.sourceNo || '--'}</div>
                            <div v-show={row.errorStatus !== 99999} style="color: red">{this.findRenderLabel(this.getErrorSimpleType, row.errorStatus)}</div>
                        </div>
                    }
                },
                {
                    title: "退货Tracking",
                    key: "trackingNo",
                    render:(h, { row }) => {
                        return <div>{row.trackingNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineName',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId)|| '--'
                    // render: (h, { row }) => row.lineName || '--'
                },
                {
                    title: this.$t('', { defaultValue: '状态' }),
                    key: "status",
                    render: (h, { row }) => {
                        const status = row.status
                        const { label = '', theme} = this.getOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render:( h, { row })=>{
                        const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code === row.orgWarehouseCode)
                        return <div>{ wareHouse[0] ? wareHouse[0].label : '--'}</div>
                    }
                },
                {
                    title: "照片",
                    render: ( h, { row })=>{
                        let img = [];
                        if(row.picturesUrls){
                            row.picturesUrls.map((item, index) => {
                                let newUrl = item + '?image_process=image/resize,w_100&x-oss-process=image/resize,w_100'
                                img.push(
                                    <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleOperates.bind(this, {url: index, urlList: row.picturesUrls}, 'image')}>
                                        <img style="width: 50px; height: 50px;" src={newUrl} />
                                    </div>
                                )
                            });
                        }
                        else{
                            img = '--'
                        }
                        return (
                            <div style="padding: 10px 0; overflow: hidden;">
                                {img.slice(0,1)}
                            </div>
                        );
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




